function flattenTree(tree) {
  const rows = [];

  function walk(node, path = []) {
    if (!node?.children) return;

    for (const [key, child] of Object.entries(node.children)) {
      const nextPath = [...path, key];

      if (child.uuid) {
        rows.push({
          uuid: child.uuid,
          pathKeys: nextPath
        });
      }

      walk(child, nextPath);
    }
  }

  walk(tree, []);
  return rows;
}

function filterAndGroup(tree, { filter, groupBy }) {
  let rows = flattenTree(tree);

  if (filter?.path?.length) {
    rows = rows.filter(r =>
      filter.path.every((k, i) => r.pathKeys[i] === k)
    );
  }

  const groups = {};

  for (const r of rows) {
    const key =
      groupBy === "uuid"
        ? r.uuid
        : r.pathKeys[groupBy.depth] ?? "(unknown)";

    (groups[key] ??= []).push(r);
  }

  return { rows, groups };
}

export default filterAndGroup